
<template>

    <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0">
        <!-- left div-->
        <div style="height: 100%; width: 75%; float: left">
            <div style="background: black; float: left; height: 100%; width: 30%;">
                <div :style="autoHeight">
                    <video ref="adminVideoView" autoplay="autoplay" :muted="!isAdminAudioOpen" style="object-fit: cover; float: left; height: 100%; width: 100%"/>
                    <el-avatar :src="this.adminCameraIcon" @click.native="openAdminCamera" style="position: absolute; margin-left: -65px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <el-avatar :src="this.adminMicrophoneIcon" @click.native="openAdminMicrophone" style="position: absolute; margin-left: -35px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                </div>
                <div style="width: 100%; height: 1px; float: left; background: slategray"/>
                <div :style="autoHeight">
                    <video ref="operaVideoView" autoplay="autoplay" muted="muted" style="object-fit: contain; float: left; height: 100%; width: 100%"/>
                    <el-avatar v-show="this.isOperaStreamPlay" :src="this.operaAudioIcon" @click.native="openAdminAudio" style="position: absolute; margin-left: -35px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <div v-show="!this.isOperaStreamPlay" style="position: absolute; color: white; margin-top: 15px; margin-left: 10px;">手法-离线</div>
                </div>
                <div style="width: 100%; height: 1px; float: left; background: slategray"/>
                <div style="position: relative; float: left; background-color: #63a35c; margin-left: 8px; margin-top: 5px" align="left">
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white">房间号：{{ this.Global.roomId }}</span>
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white; margin-top: 30px">人数：{{ this.userList.length }}</span>
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white; margin-top: 60px">手法秘钥：{{ this.operaPassword }}</span>
                </div>

            </div>

            <div ref="usView" style="background: black; float: left; height: 100%; width: 70%;">
                <div style="background: slategray; position: absolute; float: left; height: 100%; width: 1px;"/>
                <div v-show="!this.isUsStreamPlay" style="color: white; position: absolute; float: right; margin-top: 15px; margin-left: 10px;">超声-离线</div>
                <video ref="usVideoView" autoplay="autoplay" style="object-fit: contain; height: 100%; width: 100%; z-index: 1"/>
                <el-button icon="hs-icon-full-screen el-iconfont" @click="this.usVideoFullScreen" circle
                           style="width: 50px; height: 50px; background: transparent; position: absolute; z-index: 2; margin-left: -50px; border-color: transparent;"/>
            </div>
        </div>

    </div>
</template>

<script>

    import {Vue, Component} from 'vue-property-decorator';
    import md5 from 'js-md5';
    let Base64 = require('js-base64').Base64;

    export default {
        extends: Vue,
        data: function () {
            return {
                operaPassword: '',
                isSending: false, // 是否正在发送消息
                sendMessageContent: '', // 当前输入的消息内容
                roomMessages: [], // 房间消息列表
                adminAvatar: require("@/assets/admin_avatar.png"),
                adminMicrophoneIcon: require("@/assets/micphone_on.png"),
                adminCameraIcon: require("@/assets/camera_open.png"),
                operaAudioIcon: require("@/assets/audio_open.png"),
                isAdminMicrophoneOpen: true,
                isAdminCameraOpen: true,
                isAdminAudioOpen: true,
                isOperaStreamPlay: false, // 手法流是否已播放
                isUsStreamPlay: false, // 超声流是否播放
                otherVideoWidth: 192 * window.innerHeight * 0.25 / 108,
                isSystemGoBack: false, // 是否是系统回退
                microphoneId: '', // 麦克风设备ID
                cameraId: '', // 摄像头设备ID
                isShowUserList: false, // 是否显示在线列表
                adminPublishingStreamId: 'admin_' + new Date().getTime(),
                leaveNext: null,
                fileIcon: require("@/assets/icon_file.png"),
                adminPublishConfig: {
                    "audio": this.microphoneId !== '',
                    "video": this.cameraId !== '',
                    "videoQuality": 2,
                    "horizontal": true,
                },
                userList: [], // 用户列表
                autoHeight: { // style="width: 100%; float: left;"
                    width: '100%',
                    float: 'left',
                    height: '150px'
                }
            };
        },
        beforeDestroy: function() {
            clearInterval(this.roomHeartbeatTimer);
        },
        beforeRouteLeave: function (to, from, next) {
            let that = this;
            if (this.isSystemGoBack) {
                next();
            } else {
                this.$confirm('你确定要关闭房间吗?', '关闭房间', {
                    confirmButtonText: '确  定',
                    cancelButtonText: '取  消'
                }).then(() => {
                    that.operaStreamPlayStop();
                    that.usStreamPlayStop();
                    that.sendSystemMessage(that.Global.DestoryRoomMessage, false);
                    that.roomLogout();
                    that.Global.Zego.stopPreview(that.$refs.adminVideoView);
                    that.Global.Zego.stopPublishingStream(that.adminPublishingStreamId);
                    // 退出房间,释放资源
                    setTimeout(() => {
                        // 退出房间,释放资源
                        that.Global.Zego.logout();
                        next();
                    }, 300);
                }).catch(() => {
                    // 如果取消跳转地址栏会变化，这时保持地址栏不变
                    window.history.go(1);
                });
            }
        },
        mounted: function () {
            this.addZegoCallback();
            this.adminStreamPublish();
            this.usStreamPlay();
            this.operaStreamPlay();
            this.scrollChat2Bottom();
            this.operaPassword = this.obtainOperaKey();
            let that = this;
            window.onresize = function () {
                // that.otherVideoWidth = 192 * window.innerHeight * 0.25 / 108;
                that.autoHeight.height = (window.innerWidth * 0.7 * 0.3 * 108.0 / 192.0) + 'px';
            };
        },
        methods: {
            /*
            * 开关管理员端的麦克风
            * */
            openAdminMicrophone: function() {
                this.isAdminMicrophoneOpen = !this.isAdminMicrophoneOpen;
                this.adminMicrophoneIcon = this.isAdminMicrophoneOpen ? require("@/assets/micphone_on.png") : require("@/assets/micphone_off.png");
                let res = this.Global.Zego.enableMicrophone(this.$refs.adminVideoView, this.isAdminMicrophoneOpen);
                if (!res) {
                    this.$message.info("切换失败！");
                    this.isAdminMicrophoneOpen = !this.isAdminMicrophoneOpen;
                    this.adminMicrophoneIcon = this.isAdminMicrophoneOpen ? require("@/assets/micphone_on.png") : require("@/assets/micphone_off.png");
                }
            },
            /*
            * 开关管理员端的摄像头
            * */
            openAdminCamera: function() {
                this.isAdminCameraOpen = !this.isAdminCameraOpen;
                this.adminCameraIcon = this.isAdminCameraOpen ? require("@/assets/camera_open.png") : require("@/assets/camera_close.png");
                let res = this.Global.Zego.enableCamera(this.$refs.adminVideoView, this.isAdminCameraOpen);
                if (!res) {
                    this.$message.info("切换失败！");
                    this.isAdminCameraOpen = !this.isAdminCameraOpen;
                    this.adminCameraIcon = this.isAdminCameraOpen ? require("@/assets/camera_open.png") : require("@/assets/camera_close.png");
                }
            },
            /*
            * 开关教师端的声音
            * */
            openAdminAudio: function() {
                if (this.Global.operaStreamID.length < 3) {
                    return;
                }
                this.isAdminAudioOpen = !this.isAdminAudioOpen;
                this.operaAudioIcon = this.isAdminAudioOpen ? require("@/assets/audio_open.png") : require("@/assets/audio_close.png");
            },

            /*
            * 超声画面全屏展示
            * */
            usVideoFullScreen: function () {
                this.$refs.usVideoView.requestFullscreen();
            },

            adminStreamPublish: function () {
                let that = this;
                this.Global.Zego.enumDevices(deviceInfo => {
                    if (deviceInfo.microphones) {
                        that.microphoneId = deviceInfo.microphones[0].deviceId;
                    }
                    if (deviceInfo.cameras) {
                        that.cameraId = deviceInfo.cameras[0].deviceId; // d09633b39f2ac77db765f4dde41093babda99caaa4b5babc1e641dcfce4d0546
                    }
                    that.Global.Zego.startPreview(that.$refs.adminVideoView, that.adminPublishConfig, () => {
                        that.Global.Zego.startPublishingStream(that.adminPublishingStreamId, that.$refs.adminVideoView);
                    }, err => {
                        that.$message.info("推流失败:" + err);
                    });
                }, err => {
                    that.$message.info("获取推流设备失败！");
                });
            },
            usStreamPlay: function () {
                if (this.Global.usStreamID.length > 3) {
                    this.isUsStreamPlay = this.Global.Zego.startPlayingStream(this.Global.usStreamID, this.$refs.usVideoView);
                }
            },

            usStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.usStreamID);
                this.Global.usStreamID = '';
                this.isUsStreamPlay = false;
            },

            operaStreamPlay: function () {
                if (this.Global.operaStreamID.length > 3) {
                    this.Global.Zego.startPlayingStream(this.Global.operaStreamID, this.$refs.operaVideoView);
                }
            },

            operaStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.operaStreamID);
                this.Global.operaStreamID = '';
                this.isOperaStreamPlay = false;
            },

            showUserList: function () {
                this.isShowUserList = !this.isShowUserList;
            },
            // 结束房间
            roomLogout: function() {
                let data = new FormData();
                data.append("roomID", this.Global.roomId);
                data.append("requestKey", this.requestKey());
                fetch(this.Global.ServerUrl + '/user/logout', {
                    method: 'POST',
                    body: data
                }).then(response => {
                }).catch(err => {
                });
            },

            addZegoCallback: function () {
                const that = this;

                // type Added = 0; Deleted = 1;
                this.Global.Zego.onStreamUpdated = function (type, streamList) {
                    if (streamList !== null && streamList.length > 0) {
                        streamList.forEach(item => {
                            const {stream_id} = item;
                            if (type === 0) { // Added
                                if (stream_id.startsWith("opera_")) {
                                    if (that.Global.operaStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.operaStreamID);
                                    }
                                    that.Global.operaStreamID = stream_id;
                                    that.operaStreamPlay();
                                } else if (stream_id.startsWith("us_")) {
                                    if (that.Global.usStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.usStreamID);
                                    }
                                    that.Global.usStreamID = stream_id;
                                    that.usStreamPlay();
                                }
                            } else if (type === 1) { // Deleted
                                if (stream_id.startsWith("opera_")) {
                                    that.operaStreamPlayStop();
                                } else if (stream_id.startsWith("us_")) {
                                    that.usStreamPlayStop();
                                }
                            }
                        });
                    }
                };

                this.Global.Zego.onDisconnect = function (err) {
                    that.$message.info("房间连接已断开,请检查网络后重新进入！");
                    that.Global.Zego.logout();
                    that.history.go(-1);
                };

                this.Global.Zego.onPlayStateUpdate = function (type, streamid, error) {
                    if (streamid.indexOf('us_') !== -1) {
                        that.isUsStreamPlay = (type === 0);
                    } else if (streamid.indexOf('opera_') !== -1) {
                        that.isOperaStreamPlay = (type === 0);
                    }
                };

            },
        },
    }

</script>